import { useState } from "react";
import axios from "axios";
import { Heart } from "lucide-react";
import { API } from "../lib/api";

const visitorId = () => {
  let v = localStorage.getItem("wwr_visitor");
  if (!v) { v = crypto.randomUUID(); localStorage.setItem("wwr_visitor", v); }
  return v;
};
const likedKey = (id) => `wwr_heart_${id}`;

export const HeartButton = ({ id, initial = 0 }) => {
  const [count, setCount] = useState(initial);
  const [on, setOn] = useState(() => localStorage.getItem(likedKey(id)) === "1");
  const [pop, setPop] = useState(false);

  const toggle = async () => {
    const next = !on;
    setOn(next);
    setCount((c) => Math.max(0, c + (next ? 1 : -1)));
    if (next) { setPop(true); setTimeout(() => setPop(false), 350); }
    try {
      const { data } = await axios.post(`${API}/stories/${id}/heart`, { visitor_id: visitorId(), on: next });
      setCount(data.hearts);
      next ? localStorage.setItem(likedKey(id), "1") : localStorage.removeItem(likedKey(id));
    } catch {
      setOn(!next);
      setCount((c) => Math.max(0, c + (next ? -1 : 1)));
    }
  };

  return (
    <button type="button" onClick={toggle} aria-pressed={on} aria-label={on ? "Remove heart" : "Send a heart"}
      data-testid={`heart-${id}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs transition-colors ${on ? "bg-rose-500/15 text-rose-200" : "text-neutral-400 hover:text-rose-200 hover:bg-white/5"}`}>
      <Heart size={14} className={`transition-transform ${pop ? "scale-125" : ""} ${on ? "fill-rose-400 text-rose-400" : ""}`} />
      <span data-testid={`heart-count-${id}`}>{count}</span>
    </button>
  );
};
